module.exports = __webpack_public_path__ + "static/media/COIN.5956a761.svg";